/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { __decorate } from "tslib";
import { LitElement, html } from 'lit';
import { baseStyles, property, querySlotAll } from '@cds/core/internal';
import { GridRowPositionController } from './grid-row-position.controller.js';
import styles from './grid-row.element.scss';
/**
 * Grid Row
 *
 * ```typescript
 * import '@cds/core/grid/register.js';
 * ```
 *
 * @internal
 * @element cds-grid-row
 * @cssprop --border-top
 * @cssprop --border-bottom
 * @cssprop --background
 * @cssprop --min-height
 */
export class CdsGridRow extends LitElement {
    constructor() {
        super(...arguments);
        this.gridRowPositionController = new GridRowPositionController(this);
    }
    render() {
        return html `
      <div class="private-host">
        <slot></slot>
      </div>
    `;
    }
}
CdsGridRow.styles = [baseStyles, styles];
__decorate([
    property({ type: Boolean })
], CdsGridRow.prototype, "selected", void 0);
__decorate([
    property({ type: String })
], CdsGridRow.prototype, "position", void 0);
__decorate([
    querySlotAll('cds-grid-cell')
], CdsGridRow.prototype, "cells", void 0);
